import React, { useEffect } from 'react';
import { driveitcreate } from '../../api/api';
import { useLocation, useNavigate } from 'react-router-dom';

function CriarDriveIT() {
  const location = useLocation();
  const { user, equipamentos, rooms, modelos } = location.state || {};
  const roomSuggestions = rooms;
  const modelosSuggestions = modelos;
  const navigate = useNavigate();

  useEffect(() => {
    const initEquipamento = async () => {
      const timestamp = Date.now();
      const base = equipamentos || {};

      const novoEquipamentoTemp = {
        alterado_em: new Date().toISOString(),
        nome: equipamentos ? `temp_${base.nome}` : `Novo_${timestamp}`,
        numero_serie: equipamentos ? `temp_${base.numero_serie}` : `Novo_${timestamp}`,
        ativo: false,
        comentarios: equipamentos ? base.comentarios || null : null,
        encontrado: equipamentos ? base.encontrado || null : null,
        floor: equipamentos ? base.floor || '' : '',
        fora_da_base: equipamentos ? base.fora_da_base || null : null,
        id_modelo: equipamentos ? base.id_modelo || '' : '',
        room: equipamentos ? base.room || '' : '',
        verificacao_etiqueta: equipamentos ? base.verificacao_etiqueta || null : null,
        trava_seguranca: equipamentos ? base.trava_seguranca || null : null,
      };

      const response = await driveitcreate(user, novoEquipamentoTemp);

      if (response.offline) {
        
        navigate('/DriveITEditarEquipamentos', {
          state: {
            user,
            equipamentos: response,
            rooms: roomSuggestions,
            modelos: modelosSuggestions,
          },
        });
      } else if (response && response.fields && response.pk) {        
        const equipamentoFormatado = {
          ...response.fields,
          pk: response.pk,
        };
        navigate('/DriveITEditarEquipamentos', {
          state: {
            user,
            equipamentos: equipamentoFormatado,
            rooms: roomSuggestions,
            modelos: modelosSuggestions,
          },
        });
      } else {        
        console.error('Resposta inesperada ao criar equipamento:', response);
        
      }
    };
    initEquipamento();
  }, []);

  return <></>;
}

export default CriarDriveIT;
